import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ShellComponent } from './shell/shell.component';
import { AuthGuardService } from '@fleetoperate/shared/authentication/feature-authentication';

const routes: Routes = [
  { path: '', component: ShellComponent, canActivate: [AuthGuardService]},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class RecruiterFeatureShellRoutingModule { }
